import styled from "styled-components";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import {getButtonLinkData} from "@/components/common/Buttons/Button";
import LinkButton from "@/components/common/Buttons/LinkButton";
import Text from "@/components/common/Text";
import {BUTTON_VARIANTS, TYPOGRAPHY_BANNER_VARIANTS} from "@/constants";
import {insetPaddingLeftCss, insetPaddingRightCss} from "@/styles/globalStyles";
import GridContainer from "@/components/common/GridContainer";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled.div`
	position: relative;
    z-index: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(35, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(55, BREAKPOINTS.DESKTOP)};	
	}
	
	&.highlighted {
		background: ${({ theme }) => theme.colors.paleDogwood};
		${insetPaddingLeftCss};
    	${insetPaddingRightCss};
		padding: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)} 0 ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding: ${getCssSizeValue(35, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(55, BREAKPOINTS.DESKTOP)};
		}
        &.${TYPOGRAPHY_BANNER_VARIANTS.GRAY} {
            .button {
                border: none !important;
            }
        }}
`

const Heading = styled(Text)`
	font-weight: ${({ theme }) => theme.fontWeight.bold}!important;
	margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {

	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
    }
`

const Description = styled(Text)`
	margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
	}
`

function getData(src) {
	return {
		header: src?.header || '',
		description: src?.description || '',
		highlighted: src?.highlighted,
		button: getButtonLinkData(src?.button)
	}
}

export default function TypographyBannerItem({item, variant}) {
	const { header, description, highlighted, button } = getData(item)

	const buttonVariant = variant === TYPOGRAPHY_BANNER_VARIANTS.WHITE ? BUTTON_VARIANTS.PRIMARY : BUTTON_VARIANTS.TERTIARY
	return (
		<Wrapper className={`col-desktop-8 col-tablet-8 col-mobile-8 ${highlighted ? 'highlighted' : ''} ${variant}`}>
			<div className='header-description-container'>
				<GridContainer className='no-margin'>
					<Heading className='col-desktop-14 col-mobile-8 header typo-borna typo-borna-75'>{header}</Heading>
				</GridContainer>
				<GridContainer className='no-margin'>
					<Description tag='div' className='col-desktop-14 col-mobile-8 description typo-strawford typo-strawford-125' dangerouslySetInnerHTML={getHtmlFromRedactorField(description)} />
				</GridContainer>
			</div>
			<LinkButton {...button} variant={buttonVariant } className={highlighted ? 'no-border' : ''}/>
		</Wrapper>
	)
}
